import { IDocType } from "@/@types/admin/guest/user";

const identity_cards: Array<IDocType> = [
  {
    _id: "0",
    code: 0,
    name: { ru: "Паспорт РФ" },
    description: { ru: "Паспорт гражданина Российской Федерации" },
    plaseholder: "8602326028",
    sort_order: 0,
  },
  {
    _id: "1",
    code: 1,
    name: { ru: "Паспорт моряка" },
    description: { ru: "Удостоверение личности моряка (паспорт моряка)" },
    plaseholder: "",
    sort_order: 1,
  },
  {
    _id: "2",
    code: 2,
    name: {
      ru: "Заграничный паспорт РФ",
    },
    description: {
      ru: "Общегражданский заграничный паспорт гражданина Российской Федерации",
    },
    plaseholder: "123456789",
    sort_order: 2,
  },
  {
    _id: "3",
    code: 3,
    name: { ru: "Паспорт иностранного гражданина" },
    description: { ru: "Паспорт иностранного гражданина" },
    plaseholder: "123456789",
    sort_order: 3,
  },
  {
    _id: "4",
    code: 4,
    name: { ru: "Свидетельство о рождении" },
    description: { ru: "Свидетельство о рождении" },
    plaseholder: "IIАГ741852",
    sort_order: 4,
  },
  {
    _id: "5",
    code: 5,
    name: { ru: "Удостоверение личности военнослужащего" },
    description: { ru: "Удостоверение личности военнослужащего" },
    plaseholder: "",
    sort_order: 5,
  },
  {
    _id: "6",
    code: 6,
    name: { ru: "Удостоверение личности лица без гражданства" },
    description: { ru: "Удостоверение личности лица без гражданства" },
    plaseholder: "",
    sort_order: 6,
  },
  {
    _id: "7",
    code: 7,
    name: {
      ru: "Временное удостоверение личности",
    },
    description: {
      ru: "Временное удостоверение личности, выдаваемое органами внутренних дел",
    },
    plaseholder: "",
    sort_order: 7,
  },
  {
    _id: "8",
    code: 8,
    name: {
      ru: "Военный билет",
    },
    description: {
      ru: "Военный билет военнослужащего или курсанта военной образовательной организации",
    },
    plaseholder: "АС9876543",
    sort_order: 8,
  },
  {
    _id: "9",
    code: 9,
    name: {
      ru: "Вид на жительство",
    },
    description: {
      ru: "Вид на жительство иностранного гражданина или лица без гражданства",
    },
    plaseholder: "",
    sort_order: 9,
  },
  {
    _id: "10",
    code: 10,
    name: { ru: "Справка об освобождении из мест лишения свободы" },
    description: {
      ru: "Справка об освобождении из мест лишения свободы",
    },
    plaseholder: "",
    sort_order: 10,
  },
  {
    _id: "11",
    code: 11,
    name: { ru: "Паспорт гражданина СССР" },
    description: {
      ru: "Паспорт гражданина СССР",
    },
    plaseholder: "",
    sort_order: 11,
  },
  {
    _id: "12",
    code: 12,
    name: { ru: "Паспорт дипломатический" },
    description: {
      ru: "Паспорт дипломатический",
    },
    plaseholder: "",
    sort_order: 12,
  },
  {
    _id: "13",
    code: 13,
    name: {
      ru: "Паспорт служебный",
    },
    description: {
      ru: "Паспорт служебный (кроме паспорта моряка и дипломатического)",
    },
    plaseholder: "",
    sort_order: 13,
  },
  {
    _id: "14",
    code: 14,
    name: { ru: "Свидетельство о возвращении из стран СНГ" },
    description: { ru: "Свидетельство о возвращении из стран СНГ" },
    plaseholder: "",
    sort_order: 14,
  },
  {
    _id: "15",
    code: 15,
    name: { ru: "Справка об утере паспорта" },
    description: { ru: "Справка об утере паспорта" },
    plaseholder: "",
    sort_order: 15,
  },
  {
    _id: "18",
    code: 18,
    name: { ru: "Свидетельство о предоставлении временного убежища" },
    description: {
      ru: "Свидетельство о предоставлении временного убежища",
    },
    plaseholder: "",
    sort_order: 18,
  },
  {
    _id: "19",
    code: 19,
    name: {
      ru: "Документ, удостоверяющий личность осуждённого к принудительным работам",
    },
    description: {
      ru: "Документ, удостоверяющий личность осуждённого к принудительным работам",
    },
    plaseholder: "",
    sort_order: 19,
  },
  {
    _id: "99",
    code: 99,
    name: {
      ru: "Иной документ",
    },
    description: {
      ru: "Другие документы, установленные федеральным законодательством или признаваемые в соответствии с международными договорами РФ в качестве документов, удостоверяющих личность пассажира",
    },
    plaseholder: "",
    sort_order: 99,
  },
];

export default identity_cards;
